export default function (state, val) {
    let item = state.list.filter(i => {
        return i.id === val.id;
    })[0];
    for (let k in val) {
        item[k] = val[k];
    }
}